import { styled } from "@mui/material/styles";
import { Grid, Typography, TextField } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  // width: "48%",
});

export const Field = styled(Grid)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});

export const Label = styled(Typography)({
  width: "80px",
});

export const FromToContainer = styled(Grid)({
  display: "flex",
  gap: "5px",
});

export const StyledTextField = styled(TextField)({
  "& input": {
    padding: "8px",
    width: "300px",
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root ": {
    borderRadius: "8px",
    width: "300px",
  },
});

export const StyledDateTextField = styled(TextField)({
  "& input": {
    padding: "10px",
    // width: "40px",
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root ": {
    borderRadius: "8px",
    // width: "100px",
  },
});
